export enum RolesEnum {
    ADMIN = 'admin',
    USER = 'user',
    MASTER = 'master'
}
